import { BRAND_LOGO, BRAND_NAME } from '../lib/brand';

/**
 * Operator mark in the dashboard app bar. Falls back to a drawn placeholder
 * when no logo is configured, so the repo carries no operator assets.
 */
export function BrandMark({ size = 26 }: { size?: number }) {
  if (BRAND_LOGO) {
    return <img className="brand-img" src={BRAND_LOGO} alt={BRAND_NAME} height={size} />;
  }

  return (
    <span className="brand">
      <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
        <path
          d="M16 2.5c5.2 6 9 10.6 9 15.2A9 9 0 0 1 7 17.7c0-4.6 3.8-9.2 9-15.2Z"
          fill="var(--brand)"
        />
        <path
          d="M16 8.6c2.9 3.5 4.8 6 4.8 8.6a4.8 4.8 0 0 1-9.6 0c0-2.6 1.9-5.1 4.8-8.6Z"
          fill="#fff"
          opacity="0.85"
        />
      </svg>
      <span className="brand-name">{BRAND_NAME}</span>
    </span>
  );
}
